import { Component } from '@angular/core';
import { NavController, ModalController, ToastController } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { ChangeDetectorRef } from '@angular/core';
import { TurnoSimpleModal } from './mod-turno-simple';
import { CopiarPatronModal } from './mod-copiar-patron';
import { ListPage } from '../list/list';


// === TIPOS ===
type TrabId = string; // usamos CODIGO como id (string)

interface Trabajador {
  id: string;
  nombre: string;
  grupoId?: number;
  empresa?: string;
  obra?: string;
  turnoDefId?: number;   // ⬅️ nuevo
}

interface Turno { id: number; nombre: string; horaInicio: string; horaFin: string; color: string; }

@Component({
  selector: 'page-asignar',
  templateUrl: 'asignar.html'
})
export class AsignarPage {
  // ---- Calendario / fecha ----
  diasSemana = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];

  mesSeleccionado: string; // 'YYYY-MM'
  calendario: Date[][] = [];
  mesActual = 0;
  anioActual = 0;
  
  // ---- Datos ----
  trabajadores: Trabajador[] = [];
  // grupos por EMPRESA (opcional)
  grupos: { id: number; nombre: string; }[] = [];
  private _empresa2grupo = new Map<string, number>();
  private _nextGrupoId = 1;

  turnos: Turno[] = [];

  // asignaciones[fechaISO][trabajadorId] = turnoId | null
  asignaciones: { [fechaISO: string]: { [trabajadorId: string]: number | null } } = {};

  // ---- Selección de días ----
  fechasSel = new Set<string>(); // YYYY-MM-DD

  // valor que ata el ion-datetime (ISO con día 1)
  // Estado
  mesISO: string;          // 'YYYY-MM-01'

  // lo que ya usas para tu lógica (YYYY-MM)

  // ---- Selección / vista de trabajadores ----
  searchTrab: string = '';
  showResultados: boolean = false;
  
  private _blurHideTimer: any = null;
  selTrabIds = new Set<TrabId>();        // trabajadores seleccionados para ASIGNAR
  previewTrabId: TrabId | null = null;   // trabajador para VER su calendario

  turnosCargados = false;

  constructor(
    private cdr: ChangeDetectorRef,
    public variables: VariablesProvider,
    public navCtrl: NavController,
    private funciones: FuncionesProvider,
    private modalCtrl: ModalController,
    private toast: ToastController
  ) {
    const hoy = new Date();
    this.mesActual = hoy.getMonth();
    this.anioActual = hoy.getFullYear();
    this.mesSeleccionado = this.anioActual + '-' + ('0' + (this.mesActual + 1)).slice(-2);

    this.cargarInicial();
  }


// al enfocar, abrimos siempre (aunque no haya texto)
abrirResultados() {
  this.showResultados = true;
}


// si haces click dentro, evita que el blur cierre la lista antes
addTrab(t: Trabajador) {
  if (this._blurHideTimer) { clearTimeout(this._blurHideTimer); this._blurHideTimer = null; }
  this.selTrabIds.clear(); 
  this.selTrabIds.add(t.id);
  this.searchTrab = '';
  this.showResultados = false;
}


// devolver resultados: si no hay texto, devuelve TODOS (capado a N)
resultadosBusqueda(): Trabajador[] {
  var q = (this.searchTrab || '').toLowerCase().trim();

  // sin texto → muestra todos (capado, p. ej. 50 primeros)
  if (!q) {
    var lista = [];
    for (var i = 0; i < this.trabajadores.length; i++) {
      lista.push(this.trabajadores[i]);
      if (lista.length >= 50) break; // limita para no saturar
    }
    return lista;
  }

  // con texto → filtra por nombre
  var out = [];
  for (var j = 0; j < this.trabajadores.length; j++) {
    var t = this.trabajadores[j];
    if ((t.nombre || '').toLowerCase().indexOf(q) !== -1) out.push(t);
    // if (out.length >= 50) break; // si quieres limitar también
  }
  return out;
}

// al escribir, solo refrescamos (la lista ya está abierta)
onBuscarChange() {
  // aquí solo recalculas bindings; no hace falta nada más
  // si quisieras cerrar cuando no hay texto: this.showResultados = (this.searchTrab || '').trim().length > 0;
}

// al perder el foco, esperamos un poco para permitir el click en un item
cerrarResultadosConDelay() {
  var self = this;
  this._blurHideTimer = setTimeout(function() {
    self.showResultados = false;
  }, 200);
}
  ionViewDidEnter() {
    if (!this.mesISO) {
      const hoy = new Date();
      const y = hoy.getFullYear();
      const m = ('0' + (hoy.getMonth() + 1)).slice(-2);
      this.mesISO = `${y}-${m}-01`;
      this.mesSeleccionado = `${y}-${m}`;
    }
    this.construirCalendario();
  }

  onMesChange(value: any) {
    // ion-datetime suele pasar string ISO. Si no, usa el actual.
    const iso = (typeof value === 'string' && value) ? value : this.mesISO;
    if (!iso) return;
  
    const d = new Date(iso);
    if (isNaN(d.getTime())) {
      // Si viene algo raro, no toques el estado
      return;
    }
  
    const y = d.getFullYear();
    const m = ('0' + (d.getMonth() + 1)).slice(-2);
  
    // fijas SIEMPRE el día 1 para evitar brincos de mes
    this.mesISO = `${y}-${m}-01`;
    this.mesSeleccionado = `${y}-${m}`;
  
    // Reconstruye el calendario después de que Angular procese el ngModel
    Promise.resolve().then(async () => {
      this.construirCalendario();

      // Si hay alguien en preview, carga SOLO ese
    if (this.previewTrabId) {
      await this.cargarAsignacionesMes(this.previewTrabId);
    } else {
      // Si prefieres: si hay solo 1 seleccionado, carga ese
      if (this.selTrabIds.size === 1) {
        const unico = Array.from(this.selTrabIds)[0];
        await this.cargarAsignacionesMes(unico);
      }
  }});
  }

  ngOnInit() {
    const hoy = new Date();
    const y = hoy.getFullYear();
    const m = ('0' + (hoy.getMonth() + 1)).slice(-2);
    this.mesISO = `${y}-${m}-01`;
    this.mesSeleccionado = `${y}-${m}`;
    this.construirCalendario();
  }

  // ======= HELPERS para la plantilla =======
  get selTrabList(): TrabId[] { return Array.from(this.selTrabIds); }

  nombreTrabajador(id: TrabId | null): string {
    if (id === null || id === undefined) return 'Trabajador';
    for (let i = 0; i < this.trabajadores.length; i++) {
      const t = this.trabajadores[i];
      if (t.id === id) return t.nombre || 'Trabajador';
    }
    return 'Trabajador';
  }
  // =========================================

  private getFirst(obj: any, keys: string[], def: any = undefined) {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
    }
    return def;
  }
  
  construirCalendario() {
    try {
      if (!this.mesSeleccionado || this.mesSeleccionado.length < 7) return;
  
      const [yStr, mStr] = this.mesSeleccionado.split('-');
      const y = +yStr;
      const m = +mStr - 1; // 0-11
      if (isNaN(y) || isNaN(m)) return;
  
      this.anioActual = y;
      this.mesActual = m;
  
      const primerDia = new Date(y, m, 1);
      const ultimoDia = new Date(y, m + 1, 0);
  
      // 0 = lunes
      const offsetInicio = (primerDia.getDay() + 6) % 7;
      const offsetFin = (6 - (ultimoDia.getDay() + 6) % 7);
  
      const inicio = new Date(y, m, 1 - offsetInicio);
      const fin = new Date(y, m, ultimoDia.getDate() + offsetFin);
  
      const semanas: Date[][] = [];
      // cursor local para no modificar objetos ya pintados
      for (let c = new Date(inicio); c <= fin; c.setDate(c.getDate() + 1)) {
        const semanaIdx = Math.floor((c.getTime() - inicio.getTime()) / (1000 * 60 * 60 * 24 * 7));
        if (!semanas[semanaIdx]) semanas[semanaIdx] = [];
        semanas[semanaIdx].push(new Date(c));
      }
  
      // asigna todo de golpe para evitar parpadeos
      this.calendario = semanas;

      

    } catch (e) {
      console.log('Error construirCalendario:', e);
    }
  }

  async cargarInicial() {
    await this.cargarTrabajadoresDesdeAPI();
    await this.cargarTurnosDesdeAPI();
    this.construirCalendario();
  
    // si ya hay algún trabajador seleccionado al iniciar
    if (this.selTrabIds.size === 1) {
      const unico = Array.from(this.selTrabIds)[0];
      await this.cargarAsignacionesMes(unico);
    } else if (this.previewTrabId) {
      await this.cargarAsignacionesMes(this.previewTrabId);
    } else {
      // si no hay ninguno, carga vacío
      await this.cargarAsignacionesMes('');
    }
  
    // asegura estructura base del mes
    const fechas = this.fechasDelMes();
    for (let i = 0; i < fechas.length; i++) {
      const iso = this.toISO(fechas[i]);
      if (!this.asignaciones[iso]) this.asignaciones[iso] = {};
    }
  }
  

  // Mapear EMPRESA -> grupo numérico
  private grupoPorEmpresa(empresa: string | undefined): number | undefined {
    const key = empresa && empresa.trim() ? empresa.trim() : '';
    if (!key) return undefined;
    if (!this._empresa2grupo.has(key)) {
      const gid = this._nextGrupoId++;
      this._empresa2grupo.set(key, gid);
      this.grupos.push({ id: gid, nombre: key });
    }
    return this._empresa2grupo.get(key);
  }

  // PON esto dentro de la clase AsignarPage (por ejemplo arriba de cargarInicial)
private getFiltroBackend(): string {
  // Accedemos con bracket notation para que TS no exija que existan las props
  const v: any = this.variables || {};
  // elige el que uses realmente en tu backend; deja varios por compatibilidad
  return v.CLIENTES_RAZSOCIAL || v.CLIENTE || v.USER || v.user || v.usuario || '' ;
}

async cargarTrabajadoresDesdeAPI() {
  const filtro = this.getFiltroBackend(); // <-- usa el helper

  
  
    
    this.funciones.obtienetrabajadores("654321123456").then(
      dat => {
  
        const data = dat as any[];
        
  
  //  const data = await this.funciones.obtienetrabajadores(filtro) as any[];
  const lista: Trabajador[] = [];
    
  

  for (let i = 0; i < data.length; i++) {
    const r: any = data[i] || {};
    const id: string = String(
      r.CODIGO != null ? r.CODIGO :
      (r.id != null ? r.id : r.ID)
    );
    const nombre: string  = r.NOMBRE != null ? r.NOMBRE : (r.nombre || 'Trabajador');
    const empresa: string = r.EMPRESA != null ? r.EMPRESA : (r.empresa || '');
    const obra: string    = r.OBRA    != null ? r.OBRA    : (r.obra || '');
    const grupoId = this.grupoPorEmpresa(empresa);

    const turnoDefIdRaw = (r.TURNO != null ? r.TURNO : (r.turno != null ? r.turno : r.TURNO_ID));
    const turnoDefId = Number(turnoDefIdRaw);
    const tDef = isNaN(turnoDefId) ? undefined : turnoDefId;
    
    lista.push({ id, nombre, empresa, obra, grupoId, turnoDefId: tDef });

  }
  this.trabajadores = lista;
 
});
    
  
}

private labelTurnoPorDefecto(): string {
  if (this.selTrabIds.size === 1) {
    const unicoId = Array.from(this.selTrabIds)[0];
    const trab = this.trabajadores.find(function(t){ return t.id === unicoId; });
    const tieneDef = trab && typeof trab.turnoDefId !== 'undefined' && trab.turnoDefId !== null;
    if (tieneDef) {
      const tu = this.turnos.find(function(x){ return x.id === (trab as any).turnoDefId; });
      if (tu) {
        const rango = (tu.horaInicio && tu.horaFin) ? (' (' + tu.horaInicio + ' – ' + tu.horaFin + ')') : '';
        return tu.nombre + rango;
      } else {
        return 'Por defecto: Turno ' + (trab as any).turnoDefId;
      }
    }
  }
  return 'Por defecto (según trabajador)';
}


async cargarTurnosDesdeAPI() {
  const filtro = this.getFiltroBackend();
  try {
    const data = await this.funciones.obtieneturnos("654321123456") as any[];

    

    const lista: Turno[] = [];
    for (let i = 0; i < (data || []).length; i++) {
      const r: any = data[i] || {};

      // ID puede venir con varios nombres
      const idRaw = this.getFirst(r, ['ID', 'IDTURNO', 'CODIGO', 'Codigo', 'codigo', 'id']);
      const idNum = Number(idRaw);

      if (isNaN(idNum)) continue;

      // Nombre del turno
      const nombre = this.getFirst(r, ['NOMBRE', 'NOMBRETURNO', 'TURNO', 'nombre', 'descripcion'], 'Turno ' + idNum);

    // IMPORTANTES en tu API:
      const horaInicio = this.getFirst(r, ['HORA_ENTRADA', 'HORAINICIO', 'HORA_INICIO', 'ENTRADA', 'HORAENTRADA', 'entrada', 'inicio'], '--');
      const horaFin    = this.getFirst(r, ['HORA_SALIDA',  'HORAFIN',    'HORA_FIN',    'SALIDA',  'HORASALIDA', 'salida',  'fin'],    '--');

      // Color (opcional)
      const color = this.getFirst(r, ['COLOR', 'color'], '#7f8c8d');

      lista.push({ id: idNum, nombre: String(nombre), horaInicio: String(horaInicio), horaFin: String(horaFin), color: String(color) });
    }

    
    this.turnos = lista;
    this.turnosCargados = this.turnos.length > 0;
  } catch (e) {
    console.log('Error cargando turnos:', e);
    // Fallback mínimo para no dejarte bloqueado
    this.turnos = [
      { id: 0, nombre: 'Libre', horaInicio: '--', horaFin: '--', color: '#7f8c8d' }
    ];
    this.turnosCargados = false;
  }
}



  fechasDelMes(): Date[] {
    const arr = this.mesSeleccionado.split('-');
    const anio = +arr[0], mes = +arr[1];
    const ultimo = new Date(anio, mes, 0).getDate();
    const lista: Date[] = [];
    for (let d = 1; d <= ultimo; d++) lista.push(new Date(anio, mes - 1, d));
    return lista;
  }

  // ================== UTIL ==================
  toISO(d: Date): string {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  isOtroMes(d: Date): boolean { return d.getMonth() !== this.mesActual; }

  // ================== SELECCIÓN DE DÍAS ==================
  toggleFecha(d: Date) {
    const iso = this.toISO(d);
    if (this.fechasSel.has(iso)) this.fechasSel.delete(iso); else this.fechasSel.add(iso);
  }

  seleccionarRango(que: 'LV' | 'Fines' | 'Todo') {
    this.fechasSel.clear();
    const fechas = this.fechasDelMes();
    for (let i = 0; i < fechas.length; i++) {
      const f = fechas[i]; const dow = (f.getDay() + 6) % 7; // 0=Lunes
      if (que === 'Todo' || (que === 'LV' && dow <= 4) || (que === 'Fines' && dow >= 5)) this.fechasSel.add(this.toISO(f));
    }
  }

  // ================== BUSCADOR / SELECCIÓN DE TRABAJADORES ==================




 async previewTrab(t: Trabajador) {
  if (this._blurHideTimer) { clearTimeout(this._blurHideTimer); this._blurHideTimer = null; }
  this.previewTrabId = t.id;
  this.selTrabIds.clear();
  this.selTrabIds.add(t.id);
  this.searchTrab = "";//t.nombre;
  this.showResultados = false;
  await this.asegurarAsignacionesMes(t.id);
  this.cdr.detectChanges(); // ⬅️ asegura datos del mes
}

async previewById(id: string) {
  this.previewTrabId = id;
  this.selTrabIds.clear();
  this.selTrabIds.add(id);
  this.searchTrab = this.nombreTrabajador(id);
  this.showResultados = false;
  await this.asegurarAsignacionesMes(id); // ⬅️ asegura datos del mes
  this.cdr.detectChanges();
}


  quitarSelTrab(id: TrabId) { this.selTrabIds.delete(id); if (this.previewTrabId === id) this.previewTrabId = null; }
  limpiarSelecciones() { this.selTrabIds.clear(); this.previewTrabId = null; }

  
  async abrirAsignarTurnoDirecto() {
    const numDias = this.fechasSel.size;
    const numTrab = this.selTrabIds.size;
    if (!numDias || !numTrab) {
      this.toast.create({ message: 'Selecciona al menos 1 día y 1 trabajador.', duration: 1600 }).present();
      return;
    }
  
    if (!this.turnosCargados || this.turnos.length <= 1) {
      await this.cargarTurnosDesdeAPI();
    }
    if (!this.turnosCargados || this.turnos.length <= 1) {
      this.toast.create({ message: 'No hay turnos disponibles en el servidor.', duration: 1800 }).present();
      return;
    }
  
    const defaultLabel = this.labelTurnoPorDefecto();
  
    const m = this.modalCtrl.create(
      TurnoSimpleModal,
      { turnos: this.turnos, defaultLabel },
      { enableBackdropDismiss: false }
    );
  
    m.onDidDismiss(async (res) => {
      if (!res || !res.ok) return;
  
      // turnoId: number | null (null = por defecto)
      const turnoId = res.turnoId as (number | null);
  
      // 🟢 Derivamos el nombre a enviar a la API:
      // - Si eligió “por defecto”: usa la etiqueta calculada (defaultLabel)
      // - Si eligió uno concreto: busca su nombre en this.turnos
      let turnoNombre: string;
      if (turnoId === null) {
        turnoNombre = defaultLabel;
      } else {
        const tu = this.turnos.find(t => t.id === turnoId);
        turnoNombre = tu ? (tu.nombre || '') : '';
      }

      if (turnoNombre==""){turnoNombre="borrame";}
  
      const dias = Array.from(this.fechasSel);
      const trabs = Array.from(this.selTrabIds);
  
      // 1) aplica en memoria (seguimos guardando sólo el ID, como antes)
      for (let i = 0; i < dias.length; i++) {
        const iso = dias[i];
        if (!this.asignaciones[iso]) this.asignaciones[iso] = {};
        for (let j = 0; j < trabs.length; j++) this.asignaciones[iso][trabs[j]] = turnoId;
      }
  
      // 2) persiste en backend **con ID y NOMBRE**
      const user = this.getUserForApi();
      for (let i = 0; i < dias.length; i++) {
        const iso = dias[i];
        for (let j = 0; j < trabs.length; j++) {
          try {
            await this.funciones.guardaAsignaciones(
              user,
              iso,
              String(trabs[j]),
              turnoId,          // puede ser null
              turnoNombre       // string (ej.: "Por defecto (según trabajador)" o "Mañana")
            );
          } catch (e) {
            console.log('Error guardando asignaciones:', e);
            this.toast.create({ message: 'No se pudo guardar. Revisa conexión.', duration: 1600 }).present();
          }
        }
      }
  
      // limpiar sólo días seleccionados
      this.fechasSel.clear();
  
      // mantener preview si hay sólo uno
      if (this.selTrabIds.size === 1) {
        this.previewTrabId = Array.from(this.selTrabIds)[0];
      } else {
        // this.previewTrabId = null;
      }
    });
  
    m.present();
  }
  
  private getUserForApi(): string {
    const v: any = this.variables || {};
    return v.CLIENTES_RAZSOCIAL || v.CLIENTE || v.USER || v.user || '';
  }

  salir(){
    this.navCtrl.push(ListPage);
 }
  
  async cargarAsignacionesMes(trabId: string) {
    const user = this.getUserForApi();
    const partes = this.mesSeleccionado.split('-');
    const anio = +partes[0], mes = +partes[1];
  
    try {
      const rows = await this.funciones.obtieneAsignacionesMes(user, anio, mes, trabId).toPromise();
  
      // Asegura filas del mes
      const fechas = this.fechasDelMes();
      for (var i = 0; i < fechas.length; i++) {
        var iso = this.toISO(fechas[i]);
        if (!this.asignaciones[iso]) this.asignaciones[iso] = {};
        // Limpia el valor anterior de ESTE trabajador para evitar datos obsoletos
        if (this.asignaciones[iso].hasOwnProperty(trabId)) {
          delete this.asignaciones[iso][trabId];
        }
      }
  
      // Inyecta las del backend
      for (var j = 0; j < rows.length; j++) {
        var r = rows[j] || {};
        var fecha = r.fecha;
        var turno = (r.turno_id === null || typeof r.turno_id === 'undefined') ? null : Number(r.turno_id);
        if (!this.asignaciones[fecha]) this.asignaciones[fecha] = {};
        this.asignaciones[fecha][trabId] = isNaN(turno as any) ? null : turno;
      }
  
    } catch (e) {
      console.log('Error cargarAsignacionesMesTrabajador:', e);
      // Si hay error, al menos asegura las fechas (ya hecho arriba)
    }
  }
    
  private async asegurarAsignacionesMes(id) {
    if (this.variables.asignacionesCargadasMes !== this.mesSeleccionado) {
      await this.cargarAsignacionesMes(id);
    }
  }
  


  // ================== COPIAR PATRÓN (aparte) ==================
  abrirCopiarPatron() {
    const m = this.modalCtrl.create(CopiarPatronModal, {
      trabajadores: this.trabajadores,
      usarDiasSel: this.fechasSel.size > 0,
      diasSel: Array.from(this.fechasSel)
    }, { enableBackdropDismiss: false });

    m.onDidDismiss((res) => {
      if (!res || !res.ok) return;
      const srcId: TrabId = res.sourceId;
      const destIds: TrabId[] = res.destIds || [];
      const usarDiasSel: boolean = !!res.usarDiasSel;
      const dias = usarDiasSel ? Array.from(this.fechasSel) : this.fechasDelMes().map(d => this.toISO(d));
      if (!srcId || !destIds.length || !dias.length) return;

      for (let i = 0; i < dias.length; i++) {
        const iso = dias[i];
        const fila = this.asignaciones[iso] || {};
        const turnoId = (fila && (srcId in fila)) ? fila[srcId] : null;
        if (!this.asignaciones[iso]) this.asignaciones[iso] = {};
        for (let j = 0; j < destIds.length; j++) this.asignaciones[iso][destIds[j]] = turnoId;
      }
      this.toast.create({ message: 'Patrón copiado', duration: 1200 }).present();
    });

    m.present();
  }

  // ================== PINTADO EN CALENDARIO ==================
  resumenODetalleDia(d: Date): { texto: string, color?: string } {

    if (!this.previewTrabId && this.selTrabIds.size === 0) {
      return { texto: '' };
    }

    if (this.previewTrabId !== null) {
      const t = this.turnoDe(this.previewTrabId, d);
      if (t) return { texto: t.nombre, color: t.color };
  
      // si no hay ni asignado ni por defecto, sí mostramos “Sin asignar”
      const libre = this.turnos.find(x => x.id === 0);
      return { texto: libre ? libre.nombre : 'Turno por defecto', color: libre ? libre.color : '#bdc3c7' };
    } else {
      const iso = this.toISO(d);
      const fila = this.asignaciones[iso];
      if (!fila) return { texto: '' };
      const cont: { [turnoId: string]: number } = {};
      for (const k in fila) {
        const tId = fila[k];
        const key = (tId === null || tId === undefined) ? 'null' : String(tId);
        cont[key] = (cont[key] || 0) + 1;
      }
      let bestKey: string | null = null, bestVal = 0;
      for (const kk in cont) { if (cont[kk] > bestVal) { bestVal = cont[kk]; bestKey = kk; } }
      if (bestKey === null) return { texto: '' };
      if (bestKey === 'null') return { texto: 'Turno por defecto: ' + bestVal, color: '#bdc3c7' };
      const t = this.turnos.find(function (x) { return String(x.id) === bestKey; });
      return t ? { texto: t.nombre + ': ' + bestVal, color: t.color } : { texto: bestKey + ': ' + bestVal };
    }
  }
  turnoDe(trabId: TrabId, d: Date): Turno | null {
    const iso = this.toISO(d);
    const fila = this.asignaciones[iso];
  
    // ¿hay asignación explícita?
    const tieneFila = !!fila && Object.prototype.hasOwnProperty.call(fila, trabId);
    if (tieneFila) {
      const asignado = fila[trabId];
      if (asignado === null || typeof asignado === 'undefined') {
        // usar por defecto del trabajador
        const trab = this.trabajadores.find(function(t){ return t.id === trabId; });
        const tDef = trab && typeof trab.turnoDefId !== 'undefined' ? trab.turnoDefId : null;
        if (tDef !== null && typeof tDef !== 'undefined') {
          const tu = this.turnos.find(function(x){ return x.id === tDef; });
          return tu ? tu : null;
        }
        return null;
      } else {
        const tu = this.turnos.find(function(x){ return x.id === asignado; });
        return tu ? tu : null;
      }
    }
  
    // Sin asignación explícita → por defecto del trabajador
    const trab = this.trabajadores.find(function(t){ return t.id === trabId; });
    const tDef = trab && typeof trab.turnoDefId !== 'undefined' ? trab.turnoDefId : null;
    if (tDef !== null && typeof tDef !== 'undefined') {
      const tu = this.turnos.find(function(x){ return x.id === tDef; });
      return tu ? tu : null;
    }
    return null;
  }
  
  


}



// WEBPACK FOOTER //
// ./src/pages/asignar/asignar.ts